import React from 'react';
import { useLocation, useHistory, useParams } from 'react-router-dom'
import {
  Button, 
  Spinner
} from 'reactstrap'
import { useProfile  } from '../api/hooks/profile'

export function useCheckPermission(privilege, options = {}) {
  const { status, profile, can } = useProfile()
  const history = useHistory();
  // const privilegeList = typeof privileges  === 'string' ?  privilege : privilege

  // console.log(privileges)

  const hasPermission = privilege?.length > 0 ? can(privilege) : true;
  const isLawyer = can('STARTER_LAWYER_USER')
  console.log({ hasPermission, privilege,  c: can(privilege) })
 

  if (!hasPermission && status === 'success') {
    if (isLawyer) history.replace('/lawyers')
    else history.replace('/')
  }


  return {
    isLoading: status === 'loading' || !profile._id, 
    hasPermission
  }
}

export function PermissionChecker({ privilege, children }) {
  const { isLoading, hasPermission }  = useCheckPermission(privilege)
    
  const history = useHistory();


  if (isLoading) {

      return (
        <div className="d-flex w-100 mvh-100 align-items-center justify-content-center">
          <Spinner size="xl" />
        </div>
      )
  }

  if (!hasPermission) {
    return (
      <div className="d-flex flex-column justify-content-center align-items-center w-100 mvh-100">
        <h1>No Perms</h1>
        <Button color="primary" size="lg" onClick={history.goBack}>Return</Button>
      </div>
    )
  }
    
 
   
  return children
}
